import React, { Component } from "react";
import { parseISO, addHours, isAfter } from "date-fns";


import { Box, Button, ButtonGroup, Center, Spacer, IconButton, Tooltip, Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt, faEdit, faBan, faFileExport, faFilePdf, faImages, faExternalLinkAlt, faFile, faCopy, faClone, faRefresh, faBookOpenReader, faRoute } from "@fortawesome/free-solid-svg-icons";
import { ChevronDownIcon } from "@chakra-ui/icons";
import HistoryGridLayoutButtonStrip from "../../ObsHome/Components/HistoryGridLayoutButtonStrip.jsx";
import WorkflowStepModal from "./WorkflowStepModal.jsx";

import ConfigService from "../../../services/ConfigService.js";
import LocalStorageService from "../../../services/LocalStorageService.js";

import RoleManager from "../../../models/RoleManager.js";
import { AppSecurityKey } from "../../../models/AppSecurityKey.js";
import OrgRuleManager from "../../../managers/OrgRuleManager.js";
import { WorkflowStep } from "../../../models/WorkflowStepType.js";


export default class HistoryGridButtonStrip extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentStepId: null,
      showWorkflowStepModal: false,
      workflowStepOptions: null

    };

    this.configService = new ConfigService();
    this.localStorageService = new LocalStorageService();

    this.ifNoCurrentObservationThenMsg = this.ifNoCurrentObservationThenMsg.bind(this);
    this.onViewReadOnlyRequest = this.onViewReadOnlyRequest.bind(this);
    this.onUpdateRequest = this.onUpdateRequest.bind(this);
    this.onVoidRequest = this.onVoidRequest.bind(this);
    this.onPdfRequest = this.onPdfRequest.bind(this);
    this.onShareRequest = this.onShareRequest.bind(this);
    this.onResendSubscriptionNotificationsRequest = this.onResendSubscriptionNotificationsRequest.bind(this);
    this.onDownloadAsJsonRequest = this.onDownloadAsJsonRequest.bind(this);
    this.onDownloadAsStarJsonRequest = this.onDownloadAsStarJsonRequest.bind(this);
    this.onUploadAsJsonRequest = this.onUploadAsJsonRequest.bind(this);
    this.onUploadDimensionsAsJsonRequest = this.onUploadDimensionsAsJsonRequest.bind(this);

    this.onViewUserImagesRequest = this.onViewUserImagesRequest.bind(this);
    this.onViewUserDocsRequest = this.onViewUserDocsRequest.bind(this);
    this.onCopyRequest = this.onCopyRequest.bind(this);
    this.onDuplicateRequest = this.onDuplicateRequest.bind(this);
    this.onRefreshGridRequest = this.onRefreshGridRequest.bind(this);

    this.onWorkflowStepRequest = this.onWorkflowStepRequest.bind(this);
    this.onWorkflowStepModalCloseRequest = this.onWorkflowStepModalCloseRequest.bind(this);
    this.onWorkflowStepModalModalOkRequest = this.onWorkflowStepModalModalOkRequest.bind(this);
  }





  ifNoCurrentObservationThenMsg() {
    if (!this.props.currentObservation) {
      this.props.onMsgBoxRequest("Warning", "Select an Observation first!", '', 'warning');
      return true;
    }
    return false;
  }


  async onWorkflowStepRequest(e) 
  {
    if (this.ifNoCurrentObservationThenMsg()) return;
    if (!this.props.isWorkflowEnabled)
    {
      this.props.onMsgBoxRequest("Warning", "Workflow is not enabled for this schema!", '', 'warning');
      return;
    }

    var schema = this.localStorageService.getSchema(this.props.currentSchemaId);
    var workflowSchema = schema.workflow.steps;
    var currentStepId = (this.props.currentObservation.WorkflowStep?.workflowStep) ? this.props.currentObservation.WorkflowStep.workflowStep : RoleManager.toDefaultWorkflowStep(workflowSchema);
    var hasTransitionAccess = RoleManager.hasWorkflowStepTransitionAccess(workflowSchema, currentStepId, this.props.userSession.token); 
    if (!hasTransitionAccess)
    {
      this.props.onMsgBoxRequest("Warning", "You do not have rights to transition this workflow step!", '', 'warning');
      return;
    }
    var availableSteps = RoleManager.toAvailableWorkflowStepList(workflowSchema, currentStepId, this.props.userSession.token);
    var availableStepOptions= availableSteps.map((step) => 
    {
      return {id: step.id, name: step.name};
    });
    this.setState(
      {
        showWorkflowStepModal: true,
        currentStepId: currentStepId, // for modal display purposes
        workflowStepOptions: availableStepOptions
      }
    )

    // TBD: Show transition dialog
    // TBD: If cancelled, then show cancelled message
    // TBD: If saved, then update observation (like voiding) and refresh grid
        
    

  }

  onWorkflowStepModalCloseRequest() {
    this.setState({ showWorkflowStepModal: false });
  }

  async onWorkflowStepModalModalOkRequest(existingWorkflowStep, newWorkflowStep)
  {
    this.setState({ showWorkflowStepModal: false });
    //var workflowSchema = this.localStorageService.getSchema(this.props.currentSchemaId).workflow;
    //var workflowStep = RoleManager.toWorkflowStep(workflowSchema, newWorkflowStatus);
    await this.props.onWorkflowStepRequest(existingWorkflowStep, newWorkflowStep);

  }



  async onViewReadOnlyRequest() {
    if (this.ifNoCurrentObservationThenMsg()) return;
    this.props.onViewReadOnlyRequest();
  }

  async onUpdateRequest() {
    if (this.ifNoCurrentObservationThenMsg()) return;
    var orgConfig = this.localStorageService.getOrgConfig(this.props.userSession.gcid);
    var validateResponse = new OrgRuleManager(orgConfig, "update").validate(this.props.currentObservation.data.UnderInspection.InspectionDate);
    if (validateResponse.hasError) {
      this.props.onMsgBoxRequest("Warning", validateResponse.messages, '', 'warning');
      return;
    }
    this.props.onUpdateRequest();
  }

  async onVoidRequest() {
    if (this.ifNoCurrentObservationThenMsg()) return;
    var orgConfig = this.localStorageService.getOrgConfig(this.props.userSession.gcid);
    var validateResponse = new OrgRuleManager(orgConfig, "void").validate(this.props.currentObservation.data.UnderInspection.InspectionDate);
    if (validateResponse.hasError) {
      this.props.onMsgBoxRequest("Warning", validateResponse.messages, '', 'warning');
      return;
    }
    this.props.onVoidRequest();
  }

  onCopyRequest() 
  {
    if (this.ifNoCurrentObservationThenMsg()) return;
    var orgConfig = this.localStorageService.getOrgConfig(this.props.userSession.gcid);
    var validateResponse = new OrgRuleManager(orgConfig, "copy").validate(this.props.currentObservation.data.UnderInspection.InspectionDate);
    if (validateResponse.hasError) {
      this.props.onMsgBoxRequest("Warning", validateResponse.messages, '', 'warning');
      return;
    }
    this.props.onCopyRequest();
  }

  onDuplicateRequest() 
  {
    if (this.ifNoCurrentObservationThenMsg()) return;
    var orgConfig = this.localStorageService.getOrgConfig(this.props.userSession.gcid);
    var validateResponse = new OrgRuleManager(orgConfig, "duplicate").validate(this.props.currentObservation.data.UnderInspection.InspectionDate);
    if (validateResponse.hasError) {
      this.props.onMsgBoxRequest("Warning", validateResponse.messages, '', 'warning');
      return;
    }
    this.props.onDuplicateRequest();
  }


  async onPdfRequest() {
    if (this.ifNoCurrentObservationThenMsg()) return;
    await this.props.onShowPdfReport();
  }


  onShareRequest() {
    if (this.ifNoCurrentObservationThenMsg()) return;
    if (!RoleManager.hasRoleRights(AppSecurityKey.SHARE_REPORT, this.props.userSession.token))
    {
      this.props.onMsgBoxRequest("error", "You do not have rights to Share Reports");
      return;
    }
    this.props.onShowShareBox();
  }


  onResendSubscriptionNotificationsRequest()
  {
    if (this.ifNoCurrentObservationThenMsg()) return;
    if (!RoleManager.hasRoleRights(AppSecurityKey.EXPERIMENTAL_ACCESS, this.props.userSession.token))
    {
      this.props.onMsgBoxRequest("error", "You do not have rights to Resend Subscription Notifications (Experimental)");
      return;
    }
    this.props.onResendSubscriptionNotificationsRequest();
  }

  onDownloadAsJsonRequest(all, isFlat)
  {
    if (!all)
    {
      if (this.ifNoCurrentObservationThenMsg()) return;
    }
    if (!RoleManager.hasRoleRights(AppSecurityKey.EXPERIMENTAL_ACCESS, this.props.userSession.token))
    {
      this.props.onMsgBoxRequest("error", "You do not have rights to Download Observations locally (Experimental).");
      return;
    }
    this.props.onDownloadAsJsonRequest(all, isFlat);
  }


  onDownloadAsStarJsonRequest(all)
  {
    if (!all)
    {
      if (this.ifNoCurrentObservationThenMsg()) return;
    }
    if (!RoleManager.hasRoleRights(AppSecurityKey.EXPERIMENTAL_ACCESS, this.props.userSession.token))
    {
      this.props.onMsgBoxRequest("error", "You do not have rights to Download Observations locally (Experimental).");
      return;
    }
    this.props.onDownloadAsStarJsonRequest(all);
  }


  onUploadAsJsonRequest(all)
  {
    if (!all)
    {
      if (this.ifNoCurrentObservationThenMsg()) return;
    }
    if (!RoleManager.hasRoleRights(AppSecurityKey.EXPERIMENTAL_ACCESS, this.props.userSession.token))
    {
      this.props.onMsgBoxRequest("error", "You do not have rights to Upload Observations to Core API (Experimental).");
      return;
    }
    this.props.onUploadAsJsonRequest();
  }


  onUploadDimensionsAsJsonRequest()
  {
    if (!RoleManager.hasRoleRights(AppSecurityKey.EXPERIMENTAL_ACCESS, this.props.userSession.token))
    {
      this.props.onMsgBoxRequest("error", "You do not have rights to Upload Schema Dimensions to Core API (Experimental).");
      return;
    }
    this.props.onUploadDimensionsAsJsonRequest();

  }



  onViewUserImagesRequest() {
    if (this.ifNoCurrentObservationThenMsg()) return;
    this.props.onShowUserImageBox();
  }



  onViewUserDocsRequest() {
    if (this.ifNoCurrentObservationThenMsg()) return;
    this.props.onShowUserDocBox();
  }


  async onRefreshGridRequest(e) {
    this.props.onRefreshDataRequest();
  }


  async componentDidUpdate(prevProps, prevState) {
    if (this.props.searchParamsKey !== prevProps.searchParamsKey) {

    }
  }


  render() {

    const loadingIcon = this.props.isLoading ? (
      <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
    ) : (
      ""
    );

    var showEditMenu = (this.props.parentComponent === 'observationhome');
    var hasVoidRights = RoleManager.hasRoleRights(AppSecurityKey.VOID_OBSERVATION, this.props.userSession.token);
    var hasUpdateRights = RoleManager.hasRoleRights(AppSecurityKey.UPDATE_OBSERVATION, this.props.userSession.token);
    var hasReportShareRights = RoleManager.hasRoleRights(AppSecurityKey.SHARE_REPORT, this.props.userSession.token);
    var hasResendSubscriptionNotificationsRights = RoleManager.hasRoleRights(AppSecurityKey.EXPERIMENTAL_ACCESS, this.props.userSession.token);
    var hasViewReadOnlyRights = RoleManager.hasRoleRights(AppSecurityKey.VIEW_READONLY_OBSERVATION, this.props.userSession.token);
    var hasDownloadAsJsonRights = RoleManager.hasRoleRights(AppSecurityKey.EXPERIMENTAL_ACCESS, this.props.userSession.token);
    var hasUploadAsJsonRights = RoleManager.hasRoleRights(AppSecurityKey.DATA_API_UPLOAD_ACCESS, this.props.userSession.token);

    return (

      <span>

      {(this.props.isWorkflowEnabled) &&
        <WorkflowStepModal
          show={this.state.showWorkflowStepModal} 
          onModalCloseRequest={this.onWorkflowStepModalCloseRequest}
          onModalOkRequest={this.onWorkflowStepModalModalOkRequest}
          existingWorkflowStatus={this.state.currentStepId} // this is the existing workflow status
          groupOptions={(this.state.workflowStepOptions) ? this.state.workflowStepOptions: []}
        />
      }

      <Center marginTop='10px'>

        <ButtonGroup isAttached>

        {(this.props.isWorkflowEnabled) &&
          <Button
            id="workflowbutton"
            variant="solid"
            onClick={(e) => this.onWorkflowStepRequest(e)}
            leftIcon={<FontAwesomeIcon icon={faRoute} />}
            bg='#0095c8'
            color='white'
            fontSize={{ base: '12px', md: '14px', lg: '18px' }}
          >
            Workflow Step
          </Button>
      }



          <Menu>
            <MenuButton
              as={Button}
              rightIcon={<ChevronDownIcon />}
              bg='#0095c8'
              color='white'
              fontSize={{ base: '12px', md: '14px', lg: '18px' }}
            >
              Share
            </MenuButton>
            <MenuList>
              <MenuItem
                id="fileexportbutton"
                icon={<FontAwesomeIcon icon={faFileExport} />}
                onClick={(e) => this.props.onExportGridToCsvRequest(e)}
              >
                Export
              </MenuItem>

              {(hasReportShareRights) &&
              <MenuItem
                id="sharebutton"
                onClick={this.onShareRequest}
                icon={<FontAwesomeIcon icon={faExternalLinkAlt} />}
              >
                Share
              </MenuItem>
              }

              {(hasResendSubscriptionNotificationsRights) &&
              <MenuItem
                id="resendnotificationsbutton"
                onClick={this.onResendSubscriptionNotificationsRequest}
                icon={<FontAwesomeIcon icon={faExternalLinkAlt} />}
              >
                Resend Subscription Notifications
              </MenuItem>
              }

              {(hasDownloadAsJsonRights) &&
              <MenuItem
                id="downloadasjsonbutton"
                onClick={(e) => this.onDownloadAsJsonRequest()}
                icon={<FontAwesomeIcon icon={faFileExport} />}
              >
                Download Current Observation
              </MenuItem>
              }


              {(hasDownloadAsJsonRights) &&
              <MenuItem
                id="downloadasjsonallbutton"
                onClick={(e) => this.onDownloadAsJsonRequest("all", false)}
                icon={<FontAwesomeIcon icon={faFileExport} />}
              >
                Download All Observations (Tree)
              </MenuItem>
              }

              {(hasDownloadAsJsonRights) &&
              <MenuItem
                id="downloadasjsonallbutton"
                onClick={(e) => this.onDownloadAsJsonRequest("all", true)}
                icon={<FontAwesomeIcon icon={faFileExport} />}
              >
                Download All Observations (Flat)
              </MenuItem>
              }

              {(hasDownloadAsJsonRights) &&
              <MenuItem
                id="downloadasjsonstarbutton"
                onClick={(e) => this.onDownloadAsStarJsonRequest("all")}
                icon={<FontAwesomeIcon icon={faFileExport} />}
              >
                Download All Observations (Star Files)
              </MenuItem>
              }

              {(hasUploadAsJsonRights) &&
              <MenuItem
                id="uploadasjsonbutton"
                onClick={(e) => this.onUploadAsJsonRequest("all")}
                icon={<FontAwesomeIcon icon={faFileExport} />}
              >
                Upload All Observations 
              </MenuItem>
              }

              {(hasUploadAsJsonRights) &&
              <MenuItem
                id="uploadasjsonbutton"
                onClick={(e) => this.onUploadDimensionsAsJsonRequest()}
                icon={<FontAwesomeIcon icon={faFileExport} />}
              >
                Upload Current Schema Dimensions 
              </MenuItem>
              }


            </MenuList>
          </Menu>



          {(showEditMenu) &&
          <Menu>
            <MenuButton
              as={Button}
              rightIcon={<ChevronDownIcon />}
              bg='#0095c8'
              color='white'
              fontSize={{ base: '12px', md: '14px', lg: '18px' }}
            >
              Edit
            </MenuButton>

            <MenuList>

              <MenuItem
                id="updatebutton"
                disabled={!hasUpdateRights}
                onClick={this.onUpdateRequest}
                icon={<FontAwesomeIcon icon={faEdit} />}
              >
                Update
              </MenuItem>
              <MenuItem
                id="copybutton"
                onClick={this.onCopyRequest}
                icon={<FontAwesomeIcon icon={faCopy} />}
              >
                Copy
              </MenuItem>
              <MenuItem
                id="copybutton"
                onClick={this.onDuplicateRequest}
                icon={<FontAwesomeIcon icon={faClone} />}
              >
                Duplicate
              </MenuItem>

              <MenuItem
                id="voidbutton"
                disabled={!hasVoidRights}
                onClick={this.onVoidRequest}
                icon={<FontAwesomeIcon icon={faBan} />}
              >
                Void
              </MenuItem>
              : <span/>
          

            </MenuList>
          </Menu>
          }

          <Menu>
            <MenuButton
              as={Button}
              rightIcon={<ChevronDownIcon />}
              bg='#0095c8'
              color='white'
              fontSize={{ base: '12px', md: '14px', lg: '18px' }}
            >
              Details
            </MenuButton>

            <MenuList>

          {(this.props.parentComponent === 'observationhome') &&
            <MenuItem
                id="viewreadonlybutton"
                disabled={!hasViewReadOnlyRights}
                onClick={this.onViewReadOnlyRequest}
                icon={<FontAwesomeIcon icon={faBookOpenReader} />}
              >
                View Read-Only
              </MenuItem>
          }
          

              <MenuItem
                id="imagesbutton"
                onClick={this.onViewUserImagesRequest}
                icon={<FontAwesomeIcon icon={faImages} />}
                disabled={(!this.props.currentObservation?.data?.Raw?.userimages)}
              >
                Images
              </MenuItem>

          
              <MenuItem
                id="documentsbutton"
                onClick={(e) => this.onViewUserDocsRequest(e)}
                icon={<FontAwesomeIcon icon={faFile} />}
                disabled={(!this.props.currentObservation?.data?.Raw?.userdocuments)}
              >
                Documents
              </MenuItem>
   
            
            </MenuList>
          </Menu>

          <Menu >
            <MenuButton
              id="reportsbutton"
              as={Button}
              leftIcon={<FontAwesomeIcon icon={faFilePdf} />}
              rightIcon={<ChevronDownIcon />}
              bg='#0095c8'
              color='white'
              fontSize={{ base: '12px', md: '14px', lg: '18px' }}
            >
              Reports
            </MenuButton>
            <MenuList>
              {this.props.schemaReports.map((rpt) => {
                return <MenuItem id={rpt.id} icon={<FontAwesomeIcon icon={faFilePdf} />} onClick={() => this.props.onShowPdfReport(rpt.id)}  >{rpt.label}</MenuItem>
              })}
            </MenuList>
          </Menu>

          <Button
            id="refreshbutton"
            variant="solid"
            onClick={(e) => this.onRefreshGridRequest(e)}
            leftIcon={<FontAwesomeIcon icon={faRefresh} />}
            bg='#0095c8'
            color='white'
            fontSize={{ base: '12px', md: '14px', lg: '18px' }}
          >
            Refresh
          </Button>


        </ButtonGroup>
        <span style={{ float: "right" }}>{loadingIcon}</span>

        <HistoryGridLayoutButtonStrip
          onSaveLayoutRequest={this.props.onSaveLayoutRequest}
          onResetLayoutRequest={this.props.onResetLayoutRequest}
          onRestoreLayoutRequest={this.props.onRestoreLayoutRequest}
        />
      </Center>

      </span>
    );
  }
}
